module.exports = __webpack_public_path__ + "static/media/31JFA10.aed58b2b.jpg";